export const useLastSearchQuery = () => {
  const propName = 'lastSearchQuery';

  const getLastSearchQuery = (): {
    requestText: string;
    teacherId: string | null;
  } | null => {
    const result = localStorage.getItem(propName);
    const resultArray = result ? result.split(';') : [];
    return resultArray.length
      ? {
          requestText: resultArray[0],
          teacherId: resultArray[1] ? resultArray[1] : null,
        }
      : null;
  };

  const setLastSearchQuery = (value: string) => {
    localStorage.setItem(propName, value);
  };

  return {
    getLastSearchQuery,
    setLastSearchQuery,
  };
};
